import React, { useCallback } from 'react';
import { AccessCard, mergeOptions } from 'ui';
import { ComplexValue } from 'app/types-shared';
import { VisibleForFieldsProps } from './types';
import { revertValueItems } from './selectors';
import styles from './visible-for-fields.scss';

export const VisibleForFields: React.FC<VisibleForFieldsProps> = ({
  options = [],
  invalidOptions = [],
  valueItems = [],
  initialValueItems = [],
  loadingText = undefined,
  validation, readOnly, readOnlyLabel, onEmptyOptions = null,
  onChange,
  fetching,
  label
}) => {

  const changeHandler = useCallback((values: ComplexValue<number>[]) => {

    const mergedOptions = mergeOptions(options, initialValueItems);
    const excludedValues = revertValueItems(values, mergedOptions);

    onChange(excludedValues);
  }, [options, initialValueItems, onChange]);

  const allOptions = mergeOptions(options, initialValueItems);
  const excludedItems = revertValueItems(valueItems, allOptions);

  const shouldShowAccessCard = (Array.isArray(options) && options.length > 0)
    || (Array.isArray(initialValueItems) && initialValueItems.length > 0);

  return <div className="row">
    {
      !!fetching
        ? <div id="visible-for-fields-loading" className={styles.loading}>
          <div className={styles.spinLoader} />
          {!!loadingText && <div className={styles.loadingText}>&nbsp;{loadingText}</div>}
        </div>
        : shouldShowAccessCard &&
        <AccessCard
          componentId={'visibleForFields'}
          className={undefined}
          useLabelOption={false}
          options={options}
          valueItems={excludedItems}
          initialValueItems={initialValueItems}
          invalidOptions={invalidOptions}
          validation={validation}
          onChange={changeHandler}
          removeLabel={undefined}
          onDelete={undefined}
          readOnly={readOnly}
          readOnlyLabel={readOnlyLabel}
          label={label} />
        || onEmptyOptions}
  </div>;
};
